import { QueryBuilderSelector } from './QueryBuilderSelector';
import { useEffect, useState } from 'react';
import { ORDER } from './DataPanelConstants';
import { getOrderAlias, getOrderType } from './QueryBuilderUtils';

interface QueryBuilderOrderSelectorProps {
  value: string;
  aliasArr: string[];
  onChange: (e: string) => void;
}

export const QueryBuilderOrderSelector = ({ value, aliasArr, onChange }: QueryBuilderOrderSelectorProps) => {
  const valueArr = value.split('.');
  const [orderOption, setOrderOption] = useState<ORDER>(getOrderType(valueArr[1]) ?? ORDER.DESCENDING);
  const [orderAlias, setOrderAlias] = useState<string>(getOrderAlias(valueArr[1]) ?? '');

  useEffect(() => {
    onChange(['ORDER topology.', orderOption, '(', orderAlias, ')'].join(''));
  }, [orderOption, orderAlias]);

  return (
    <div className="flex grow flex-row divide-x rounded-md border-2 mt-2 py-2">
      <div className="text-base w-[75px] text-center">Order</div>
      <div className="min-w-[150px] pl-2 flex flex-row">
        <div>
          <div className="text-sm leading-5">Order Type</div>
          <div className="flex selector-container">
            <div className="w-[150px]">
              <QueryBuilderSelector
                value={orderOption}
                placeHolder="Select Order Type"
                options={[ORDER.ASCENDING, ORDER.DESCENDING]}
                onChange={e => setOrderOption(e)}
              ></QueryBuilderSelector>
            </div>
          </div>
        </div>
        <div className="pr-2">
          <div className="text-sm leading-5">Order By</div>
          <div className="flex selector-container">
            <div className="w-[250px]">
              <QueryBuilderSelector
                value={orderAlias}
                placeHolder="Select Order By"
                options={aliasArr}
                onChange={e => setOrderAlias(e)}
              ></QueryBuilderSelector>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
